import React from 'react';
import { useReportSelect } from './useReportSelect';
import { PopupSelect } from '../../../CommonComponents/OPL/Select/PopupSelect/PopupSelect';
import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import { MarginProps } from '../../../theme/styledProps';
import { ReportOption } from '../../types';
import { useSelectedReport } from '../../state';
import { Label } from '../../../CommonComponents/OPL/Label/Label';

export const ReportSelect: React.FC<MarginProps> = props => {
  const { data, actions } = useReportSelect();

  const { selectedReport } = useSelectedReport();

  if (!data) {
    return null;
  }

  const { reportOptions } = data;

  const { onSelectReport } = actions;

  return (
    <Wrapper {...props}>
      <Label htmlFor="adv-select-report" mb="4">
        Report
      </Label>

      <PopupSelect
        placeholder="Select Report"
        inputId="adv-select-report"
        value={selectedReport}
        options={reportOptions}
        onChange={report => {
          onSelectReport(report as ReportOption);
        }}
      />
    </Wrapper>
  );
};
